
window.addEventListener("load",function(event) {
  $ ( document ).ready(function() {
    var totalHeight = 0;
    $(".product__description").children().each(function(){
      totalHeight = totalHeight + $(this).outerHeight(true);
    });
    if (totalHeight < 282 ){
      $('a.readmore').hide();
    } else {
      $('a.readmore').show();
    }

    $('a.readmore').click(function(e) {
      e.preventDefault();
      $('.product__description').css("height", "auto");
      $('a.readless').fadeIn();
      $(this).hide();
    });
    
    $('a.readless').click(function(e) {
      e.preventDefault();
      $('.product__description').css("height", "255px");
      $('a.readmore').fadeIn();
      $(this).hide();
    });
  });
},false)
document.addEventListener("click", function (event) {
var acc = event.target.closest(".accordion-product");

if (acc) {
  var containClass = acc.classList.contains('active-arcodition');
  
  // Remove active class from all accordions
  // document.querySelectorAll('.accordion-product').forEach(el => el.classList.remove('active-arcodition'));

  if (!containClass) {
    acc.classList.add("active-arcodition");
  } else {
    acc.classList.remove("active-arcodition");
  }

  var panel = acc.nextElementSibling;

  if (panel) {
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      // document.querySelectorAll('.panel-accordion').forEach(el => el.style.maxHeight = null);
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
}
});
document.addEventListener('DOMContentLoaded', function () {
var acc = document.getElementsByClassName("accordion-product");
acc.forEach(function (el) {
  if(el.classList.contains('active-arcodition')) {
    var panel = el.nextElementSibling;
    console.log('panel.style.maxHeight', panel.scrollHeight, panel.outerHeight);
    if (panel && panel.scrollHeight > 0) {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }
})
var i;

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');

  return msie > 0 || trident > 0;
}

if (!isIE()) return;
const hiddenInput = document.querySelector('#{{ product_form_id }} input[name="id"]');
const noScriptInputWrapper = document.createElement('div');
const variantSwitcher =
  document.querySelector('variant-radios[data-section="{{ section.id }}"]') ||
  document.querySelector('variant-selects[data-section="{{ section.id }}"]');
noScriptInputWrapper.innerHTML = document.querySelector(
  '.product-form__noscript-wrapper-{{ section.id }}'
).textContent;
variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

document.querySelector('#Variants-{{ section.id }}').addEventListener('change', function (event) {
  hiddenInput.value = event.currentTarget.value;
});
});

document.addEventListener('click', function (e) {
  const tab = e.target.closest('.product-info-tab');
  if (!tab) return;

  [...tab.parentElement.children].forEach(sibling => sibling.classList.remove('active'));

  tab.classList.add('active');

  const selector = tab.getAttribute('target');
  const target = document.querySelector(selector);
  if (!target) return;

  [...target.parentElement.children].forEach(sibling => sibling.classList.remove('active'));

  target.classList.add('active');

  if (!target.dataset.productCustomizationWrapper) {
    document.querySelector('[data-product-form-buttons]')?.classList.remove('customization-hidden');
    document.querySelector('[data-enquiry-form-button]')?.classList.remove('customization-show');
  } else {
    target.querySelector('[data-product-customization-wrapper]')?.querySelectorAll('.panel-accordion')?.forEach(el => {
      el.style.maxHeight = el.scrollHeight + "px";
    });
    target.querySelectorAll('.accordion-product').forEach(el => {
      if (!el.classList.contains('active-arcodition')) {
        el.classList.add('active-arcodition');
      }
    });

    document.querySelector('[data-product-form-buttons]')?.classList.add('customization-hidden');
    document.querySelector('[data-enquiry-form-button]')?.classList.add('customization-show');

    // Initialize scroll detection for variant options after tab is visible
    if (typeof initVariantOptionsScroll === 'function') {
      setTimeout(() => {
        initVariantOptionsScroll();
      }, 100);
    }
  }
});

document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.swatch-input__label');
  if (!swatch) return;

  const variantOptions = swatch.closest('.product-form__input');

  if (!variantOptions) return;
  const mainImg = variantOptions.querySelector('.variant-swatch-main-image');
  
  if (!mainImg) return;

  const swatchStyle = swatch.querySelector('.swatch')?.style.getPropertyValue('--swatch--background');
  if (swatchStyle) {
    mainImg.style.setProperty('--swatch--background', swatchStyle);
  }

  const labelText = variantOptions.querySelector('[data-selected-value]');

  if(labelText) {
    labelText.innerHTML = `:${swatch.title}`
  }
});

document.addEventListener('change', function (e) {
  const input = e.target.closest('[data-product-customization]');
  if(!input) return;

  const target = document.querySelector(input.dataset.productCustomization);
  if(!target || !input.checked) return;
  
  target.value = input.value;
})
